<script>
import DataLabel from '@/js/components/common/labels/DataLabel';

export default {
    name: 'TagLabel',

    functional: true,

    props: {
        tag: {type: Object, required: true},
        hideIcon: {type: Boolean},
        largeIcon: {type: Boolean},
    },

    render(createElement, {props, data, parent}) {
        const iconClass = 'fa fa-fw fa-tag' + (props.largeIcon ? ' fa-lg' : '');

        data.props = {
            item: props.tag,
            hideIcon: props.hideIcon,
            iconClass: iconClass,
            none: parent.$t('tags.nil'),
        };

        if (!props.tag.related) {
            return createElement(DataLabel, data);
        }

        return createElement(DataLabel, data);
    },
};
</script>
